import React from 'react';
import SvgClock from 'src/assets/svg/SvgClock.svg';

const ListingParkHours = ({ workHours }) => {
    return (
        <div className="px-2 px-md-0">
            <div className="snif-m1 snif-semibold mt-1 mb-3">Park hours</div>
            <div className="d-flex justify-content-between">
                <div>
                    <SvgClock />
                </div>
                <p className="snif-p text-deep" style={{ width: 'calc(100% - 40px)' }}>
                    {workHours}
                </p>
            </div>
            <div className="my-4">
                <hr />
            </div>
        </div>
    );
};

export default ListingParkHours;
